module.exports = __webpack_public_path__ + "img/defualt_photo.a6adb731.png";